<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="$emit('dialog-toggle')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t("script.helpTitle") }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-container>
      <v-main class="preserve-spacing">
        <h3>{{ $t("script.exampleFarenheitTitle") }}</h3>
        <code>{{ $t("script.placeHolderContent") }}</code>

        <v-divider></v-divider>
        <br />
        <h3>{{ $t("script.exampleAverageTitle") }}</h3>
        <code>{{ $t("script.exampleAverage") }}</code>

        <v-divider></v-divider>
        <br />
        <h3>{{ $t("script.exampleBlackIceTitle") }}</h3>
        <code>{{ $t("script.exampleBlackIce") }}</code>

        <v-divider></v-divider>
        <br />
        <h3>{{ $t("script.exampleDewPointTitle") }}</h3>
        <code>{{ $t("script.exampleDewPoint") }}</code>

        <v-divider></v-divider>
        <br />
        <h3>{{ $t("script.example420Title") }}</h3>
        <code>{{ $t("script.example420") }}</code>

        <v-divider></v-divider>
        <br />
        <h3>{{ $t("script.example010Title") }}</h3>
        <code>{{ $t("script.example010") }}</code>

        <v-divider></v-divider>
        <br />
        <h3>{{ $t("script.exampleMCF88Title") }}</h3>
        <code>{{ $t("script.exampleMCF88") }}</code>
      </v-main>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "ExampleScripts",
};
</script>
<style>
.user-select-enabled {
  user-select: auto;
}
.preserve-spacing {
  white-space: pre-wrap;
}
</style>
